import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(4),

    },
    spacer: {
      paddingTop: theme.spacing(4),
    },
  }),
);

export default function TermsConditionsPage() {
  const classes = useStyles(baseTheme);
  return (
    <Grid item container direction="column" className={classes.root}>
      <Typography variant="h4" color="primary">
        Terms and Conditions of Use Agreement
      </Typography>

      <Typography>
        Date of last revision: March 15, 2022
      </Typography>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        1. TERMS OF USE
      </Typography>
      <ol>
        <li>
          Please read these Terms and Conditions carefully. By using Reliht
          (a registered trademark and a registered assumed name of Isaiah 601, Inc.,
          a Minnesota corporation) software as a service in any form, you are agreeing
          to these Terms and Conditions.
        </li>
        <li>
          THIS IS A LEGALLY BINDING AGREEMENT (THE "AGREEMENT") BETWEEN YOU AND RELIHT.
        </li>
        <li>
          By accessing, browsing, creating an account, or otherwise using the Reliht app
          or website, you have agreed to these terms and conditions and you agree to comply
          with and abide by them as they appear below, or as they are amended at a future
          date by Reliht.
        </li>
        <li>
          These terms and conditions may be amended by Reliht, with or without notice, in its sole discretion.
        </li>
        <li>
          Reliht may refuse service, close accounts, and change eligibility requirements at any time.
        </li>
        <li>
          You agree that you will not use this service in any way that violates any laws or regulations.
        </li>
        <li>
          "Represent", "certify", and "warrant" or "warranting" is the making of a legally enforceable promise.
        </li>
      </ol>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        2. DESCRIPTION OF SERVICE; TYPES OF ACCOUNTS
      </Typography>
      <ol>
        <li>
          <u>Reliht Service.</u> Reliht is a <b>web-based</b> software as a service (SaaS), owned and
          provided by Isaiah 601, Inc. (hereafter “Reliht", "we", or "our") to allow you to
          record, share, maintain, and retrieve information within its various features. Reliht
          provides access to the Service (as defined below) through both its website and its mobile
          application (the “App”), and any reference in this Agreement to any use of the Service via
          either the website or the App (collectively referred to as the “Site”) includes either
          method of access.
        </li>
        <li>
          <u>Registration with Reliht.</u> Once you have registered with Reliht, you will receive access
          to a <b>note-taking</b> space where you can create a private profile and save data in the form
          of various entries to such <b>note-taking</b> space. Entries can be shared privately to a closed
          set of individuals or not anonymously via email, or publicly.
        </li>
        <li>
          <u>Types of Accounts.</u> You can choose to sign up for a "Leader" account if you are a leader,
          church, or ministry. Individuals may sign up for an "Individual" account but may upgrade to
          “Leader” account at a later date. For the purpose of this Agreement, both "Leader" and "Individual"
          accounts are referred to collectively as the "Service", unless otherwise indicated. Isaiah 601, Inc.
          provides "Leaders" and "Individuals" with access to a variety of services through Reliht, including
          but not limited to, online video access, notes, communication tools, and access to personalized
          content, all at no charge to the user. By using Reliht, you understand and agree that such usage
          may include communication from Reliht, including but not limited to, service announcements,
          notifications and other messages.
        </li>
      </ol>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        3. RELIHT MISSION; STATEMENT OF SUPPORT FOR MISSION, REMOVAL OF CONTENT THAT DOES NOT FURTHER THAT MISSION.
      </Typography>
      <br />
      Reliht is a Christian site and its mission is to further the Kingdom of God.  By creating an account
      on Reliht, you pledge your agreement with the Christian mission of Reliht and pledge that all posts you
      make, or comments you offer on the Reliht site, will further the stated mission of Reliht. Any posts or
      comments that are not congruent with the mission of Reliht, as determined by Reliht in its sole discretion,
      may be removed from the site.


      <Typography variant="h5" color="primary" className={classes.spacer}>
        4. APPLICATION
      </Typography>
      <ol>
        <li>
          <u>You, Your, User. "You"</u>, "your" or "User" means an adult user of the Service (as defined herein)
          acting independently or as parent or guardian for any minor (age 13 to 18) whom you allow to access
          the Service through your own account, and for whom you will be held strictly responsible.
        </li>
        <li>
          <u>Your Agreement to Terms By Use of Site.</u> By accessing or using the Reliht website at
          https://www.Reliht.com or https://Reliht.com (the "Site") or downloading the App and accessing
          the Service through the App, you agree that you have read, understand and agree to be bound by
          this Agreement, whether or not you are a registered User of Reliht.
        </li>
      </ol>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        5. CHANGES TO TERMS OF USE AND THE SERVICE
      </Typography>
      <br />
      We may change any of the Terms and Conditions by posting revised Terms and Conditions on our Website
      and/or by sending an email to the last email address you gave us and/or by providing a notification
      through the App. The new Terms and Conditions will be effective immediately and apply to any continued
      or new use of Reliht. We may change the website or Service or any features of the Service at any time.
      It is your responsibility to regularly check the Site to determine if there have been changes made and
      to review such changes.


      <Typography variant="h5" color="primary" className={classes.spacer}>
        6. SUBSCRIPTION; REGISTRATION DATA; ACCOUNT; SECURITY
      </Typography>
      <ol>
        <li>
          <u>Age Restrictions.</u> Reliht does not accept registrations from users who are under 18 years of age.
          By registering with Reliht, you represent that you are at least 18 years old.<br />
          A parent or legal guardian may be permitted to open an account in the name of the parent
          for use by their child if the child is at least 13 years old, but the parent is fully responsible
          for that account and all activity on the account. <br />
          By registering an account and using the site, you agree to this requirement and represent and
          certify that you are 18 years of age or older. If you are allowing an account to be used by your
          13 to 17 year old child, you agree to be responsible for the account and all activity on the account,
          and you certify that your child is no younger than 13. You also assume all responsibility for monitoring
          your child's activity.
        </li>
        <li>
          <u>Registration Information.</u> Upon registration with the Service you will create a user name and/or password
          (collectively, the "Account") in order to access certain sections of the Service and/or certain services
          available through the Service. You agree to provide accurate, current and complete information on your
          Account registration and to update it to keep it current.
        </li>
        <li>
          <u>Password and Use of Account.</u> You're responsible for keeping your Account name and password confidential.
          You're also responsible for any Account that you have access to, whether or not you authorized the use.
          You will immediately notify us of any unauthorized use of your Accounts. You are responsible for all
          activities that occur through the use of your Account. We are not responsible for any losses due to stolen
          or hacked passwords.
        </li>
        <li>
          <u>Deactivation of Your Account.</u> If you provide any information that is untrue, inaccurate, not current
          or incomplete, or Reliht has reasonable grounds to suspect that such information is untrue, inaccurate,
          not current or incomplete, or if you abuse the service provided, harass other users, make inappropriate
          or objectionable posts, or violate this Agreement in any way (as determined by Reliht in its sole
          discretion), Reliht has the right to deactivate or terminate your Account and refuse any and all current
          or future use of the Service (or any portion thereof), without liability.

        </li>
      </ol>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        7. PRIVACY POLICY
      </Typography>
      <br />
      We may use and disclose your information according to our Privacy Policy: <a href="/privacy-policy/">http://Reliht.com/privacy-policy/</a>. Our
      Privacy Policy will be treated as part of this Agreement.

      <Typography variant="h5" color="primary" className={classes.spacer}>
        8. OWNERSHIP AND RESPONSIBILITY WITH RESPECT TO USER CONTENT
      </Typography>
      <ol>
        <li>
          <u>Non-Endorsement.</u> Reliht does not endorse, support, represent or guarantee the accuracy or reliability
          of any communications or content Posted on the Service or endorse any opinions expressed via the Service.
        </li>
        <li>
          <u>You're Responsible for your Entries.</u> You are solely responsible for the entries, photos, messages, profiles,
          information, notes, text, and other content (collectively, the "User Content") that you upload, publish,
          copy, display or transmit to or share with others or create public links to (hereinafter "Post") on or
          through the Service. You understand and agree that Reliht may, but is not obligated to, review and delete or
          remove, without notice, any shared User Content in its sole discretion, including, without limitation, User
          Content that in the sole judgment of Reliht violates this Agreement or which might be offensive, illegal,
          or that might violate the rights of, harm, or threaten the safety of Users or others. You also agree that
          you must evaluate, and bear all risks associated with, the use of any User Content, including any reliance
          on the accuracy, completeness, or usefulness of any User Content.
        </li>
        <li>
          <u>User Content.</u> Reliht does not claim ownership of User Content that users Post on the Service, whether public
          or private. However, by sharing or otherwise making public any User Content on any part of the Service you
          thereby grant (and you represent and warrant that you have the right to grant) to Reliht an irrevocable,
          perpetual, non-exclusive, transferable, fully paid, worldwide license (with the right to sublicense) to use,
          reproduce, publicly display, excerpt (in whole or in part) and distribute such User Content.
        </li>
        <li>
          <u>User Feedback, Contributions.</u> By submitting ideas, suggestions, documents, and/or proposals ("Contributions")
          to Reliht, you acknowledge and agree that your Contributions do not contain confidential or proprietary
          information. Reliht is not under any obligation of confidentiality, express or implied, with respect to the
          Contributions; Reliht shall be entitled to use or disclose (or choose not to use or disclose) such Contributions
          for any purpose, in any way in any media worldwide; Reliht may have something similar to the Contributions
          already under consideration or in development; your Contributions automatically become the property of
          Reliht without any obligation of Reliht to you; and you are not entitled to any compensation or reimbursement
          of any kind from Reliht under any circumstances.
        </li>
        <li>
          <u>Disclosure of User Content.</u> You acknowledge and agree that Reliht may preserve User Content and may also
          disclose User Content if required to do so by law or in the good faith belief that such preservation or
          disclosure is reasonably necessary to: (a) comply with legal proceedings, investigations, or process; (b)
          enforce the Agreement; (c) respond to claims that any User Content violates the rights of third-parties;
          or (d) protect the rights, property, or personal safety of Reliht, its users and the public.
        </li>
      </ol>


      <Typography variant="h5" color="primary" className={classes.spacer}>
        9. GENERAL USER CONDUCT
      </Typography>
      <ol>
        <li>
          <u>Personal, Non-Commercial Use.</u> This Service is available for your personal, non-commercial use only,
          and you agree not to use it in any other way.
        </li>
        <li>
          <u>Your Representations and Warranties.</u> You represent and warrant that you either own or have permission
          to use all of the material in your emails or postings. We may use or disclose those materials as stated
          in this Agreement.
          <br />
          You will not violate or infringe on the rights of any other person by submitting through your Account,
          or otherwise post or share through this Service, anything that violates the rights of others (including
          copyright, trademark, privacy, publicity or other personal or proprietary rights).
          <br />
          You will not post or share through this service any libelous, defamatory or otherwise unlawful material.
          If Reliht receives credible information stating that any material you Post violates any of these
          representations or warranties, Reliht reserves the right to remove any of your posted material at its
          sole discretion.
        </li>
        <li>
          <u>You Won't Use Service Unlawfully.</u> You agree that you will not use the Service in any unlawful manner or in
          any other manner that could damage, disable, overburden or impair the Service.
        </li>
        <li>
          <u>You Agree Not to Abuse the Service As Follows.</u> You further agree not to use the Service, the Site,
          or the App to:
          <ol type="a">
            <li>
              harvest or collect email addresses or other contact information of Users from the Service
              by electronic or other means for the purposes of sending unsolicited emails or other
              unsolicited communications;
            </li>
            <li>
              use automated scripts to collect information from the Service or for any other purpose;
            </li>
            <li>
              upload, post, transmit, share or otherwise make available any content that we deem to be
              harmful, threatening, unlawful, defamatory, abusive, inflammatory, harassing, vulgar,
              obscene, fraudulent, invasive of privacy or publicity rights, hateful, or racially,
              ethnically or otherwise objectionable;
            </li>
            <li>
              upload, post, transmit, share or otherwise make available any User Content that you do not
              have a right to make available under any law or under contractual or fiduciary relationships;
            </li>
            <li>
              Register for an Account on behalf of an individual other than yourself, or register for an
              Account on behalf of any Leader (leader, church or ministry) other than your own or one you represent;
            </li>
            <li>
              impersonate any person or entity, including but not limited to a person or entity affiliated with
              Reliht, or falsely state or otherwise misrepresent yourself, your age or your affiliation with any
              person or entity;
            </li>
            <li>
              upload, post, transmit, share or otherwise make available any unsolicited or unauthorized advertising,
              surveys, contests, promotional materials, "junk mail", "spam", "chain letters", "pyramid schemes", or
              any other form of solicitation;
            </li>
            <li>
              upload, post, transmit, share or otherwise make publicly available on the Service any private or personal
              information of any third party, including, without limitation, addresses, phone numbers, email addresses,
              Social Security numbers, and credit card numbers;
            </li>
            <li>
              solicit personal information from anyone under 18 or solicit passwords or personal information for
              commercial or unlawful purposes;
            </li>
            <li>
              collect or store personal information about other Users;
            </li>
            <li>
              upload, post, transmit, share or otherwise make available any material that contains software viruses or
              any other computer code, files or programs designed to interrupt, destroy or limit the functionality of
              any computer software or hardware or telecommunications equipment;
            </li>
            <li>
              advertise or offer to sell any goods or services for any commercial purpose unless you have Reliht's
              written consent to do so;
            </li>
            <li>
              download any file that you know, or reasonably should know, cannot be legally obtained in such manner;
            </li>
            <li>
              interfere with or disrupt the Service, or any of our other sites, servers, or networks, or disobey any
              requirements, policies, or regulations of networks connected to the Service;
            </li>
            <li>
              forge headers or manipulate identifiers or other data in order to disguise the origin of any content
              transmitted through our Service or to manipulate your presence on our Service;
            </li>
            <li>
              take any action that imposes an unreasonably or disproportionately large load on our infrastructure;
            </li>
            <li>
              intentionally or unintentionally violate any applicable local, State, national or international law; or
            </li>
            <li>
              in any way harass any other User, person, or entity.
            </li>
            <li>
              attempt to gain unauthorized access to any portion or feature of the Site, or any other systems or
              networks connected to the Site, or to any of the services offered on or through the Site, by hacking,
              password "mining" or any other illegitimate means.
            </li>
            <li>
              scan or test the vulnerability of the Site or any network connected to the Site, nor breach the security
              or authentication measures on the Site or any network connected to the Site.
            </li>
            <li>
              take any action that imposes an unreasonable or disproportionately large load on the infrastructure of
              the Site or Relight’s systems or networks, or any systems or networks connected to the Site.
            </li>
          </ol>
        </li>
      </ol>


      <Typography variant="h5" color="primary" className={classes.spacer}>
        10. CLOSED GROUP, LEADER AND USER MESSAGES; PUBLIC LEADERS; PUBLIC LINKS; COMMENTS FEED.
      </Typography>
      <ol>
        <li>
          <u>Right to Deactivate Your Account.</u> You must act responsibly at all times, and refrain from sending messages
          that are frightening, harassing, insulting or any messages that we, in our sole discretion, deem to be
          inappropriate towards other users of the Service. Failure to abide by these guidelines can result in your
          Account being deactivated or you being denied access to certain features of the Service for a definite or
          indefinite period of time.
        </li>
        <li>
          <u>Reliht Not Obligated to Monitor or Block Content.</u> Notwithstanding any of the foregoing, you acknowledge and
          agree that Reliht has no obligation to in any way monitor, block or remove the content of private messages
          that are sent between users and/or any public links. Any User that believes that any message or messages
          received from other Users are in breach of this Agreement is encouraged to report such messages via our <a href="/connect">connect</a> form.
          Such Users are also encouraged to not respond in any manner to any of those messages.
        </li>
        <li>
          <u>Criminal Reporting.</u> If we think you have done something illegal, we can report you to the proper criminal
          authorities, but we are not obligated to make such a report.
        </li>
        <li>
          <u>Reliht Not Responsible for Leader Content.</u> Any Leader content displayed or made visible by "Leader" Users
          (leaders, churches, or ministries) to, by, or on Reliht is developed by third parties and Reliht has no
          control over that content. We do not endorse any content provided by Leaders on Reliht. We do not screen
          Leader content and you may find it inappropriate or offensive. We are not responsible and assume no
          responsibility for the content of any Leader on Reliht. Furthermore, Reliht is not responsible or liable
          (directly or indirectly) for any damage or loss caused or alleged by, or in connection with the use of,
          such Leader content.
        </li>
        <li>
          <u>Reliht Not Responsible for Linked Content.</u> Any sites displayed or linked to, by, or on Reliht are developed
          by third parties and Reliht has no control over those sites or content. We do not endorse any sites listed or
          linked on Reliht. We do not screen sites for content and you may find them inappropriate or offensive. We are
          not responsible and assume no responsibility for the content of any site listed or linked on Reliht.
          Furthermore, Reliht is not responsible or liable (directly or indirectly) for any damage or loss caused or
          alleged by, or in connection with the use of, such linked content or sites.
        </li>
        <li>
          <u>Reliht Not Responsible for Comments on Feed.</u> Any comments made and displayed on the Reliht Comment Feed is
          developed by third parties and Reliht has no control over that content. We do not endorse any comments made
          on Reliht. We do not screen comments made and you may find it inappropriate or offensive. We are not
          responsible and assume no responsibility for the comments of anyone made on the comments feed on Reliht
          Furthermore, Reliht is not responsible or liable (directly or indirectly) for any damage or loss caused
          or alleged by, or in connection with the use of such comments feed.
        </li>
        <li>
          <u>Agreement to Receive Notifications on Phone.</u>  Reliht offers notifications to your phone for certain
          content, and you agree to the receipt of these notifications.
        </li>
      </ol>


      <Typography variant="h5" color="primary" className={classes.spacer}>
        11. LIMITATIONS ON USER CONTENT
      </Typography>
      <ol>
        <li>
          In addition to any other limitations on use or content stated anywhere else in this Agreement, YOU MAY NOT:
          <ol type="a">
            <li>
              post or send public or private messages containing sexually graphic material or any other material deemed explicit by Reliht in its sole discretion;
            </li>
            <li>
              post User Content or send messages that promotes pedophilia, incest and/or bestiality;
            </li>
            <li>
              post User Content that promotes hatred towards any Leader based on race, ethnic origin, religion, gender, disability, age, veteran status, sexual orientation and gender identity; or
            </li>
            <li>
              post threats of violence or any physical or emotional harm against any person or Leader of people.
            </li>
            <li>
              Post User Content that is anti-Christian and does not further the Christian mission of Reliht.
            </li>
          </ol>
        </li>
      </ol>
      <br />
      We may block such content if you do, and report you to the authorities if you have violated the law.

      <Typography variant="h5" color="primary" className={classes.spacer}>
        12. USE AT YOUR OWN RISK; NO DUTY TO REMOVE CONTENT.
      </Typography>
      <ol>
        <li>
          <u>Service Used At Your Own Risk.</u> You agree to use the Service at your sole risk and Reliht has no liability to you for any content, including content that may be found to be offensive, indecent or objectionable.
        </li>
        <li>
          <u>No Duty For Reliht to Edit or Remove Content.</u> Reliht has no legal or contractual duty or obligation to monitor, edit, or remove any content posted or transmitted through this service (even if the content violates the policies of this Agreement). What you find objectionable or offensive may not be objectionable or offensive to another user, and you accept the risk that you may encounter language, speech or content on Reliht, or linked on Reliht, that you find offensive. While Reliht is not obligated to protect free speech rights, it is also not obligated to edit or remove offensive speech or content (even if it violates Reliht policies), and you agree and consent to this by accepting this Agreement.
        </li>
      </ol>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        13. TERMINATION AND MODIFICATION
      </Typography>
      <ol>
        <li>
          <u>Modify or Discontinue Service or Deactivate Your Account.</u> Reliht may in its sole discretion and at any time discontinue or modify the provision of the Service, or any part thereof, with or without notice. Reliht may, for any reason, and without a refund to you of any Fees, immediately deactivate or terminate your Account and any or all User Content, information and files in your Account and/or bar any further access to such files or the Service. Reliht shall not be liable to you or any third party for any termination of your access to the Service, or modification, suspension or discontinuance of the Service.
        </li>
        <li>
          <u>You May Deactivate or Terminate Your Account.</u> You may deactivate or terminate your Account by contacting Reliht via our <a href="/connect">connect</a> form. Your User Content and/or personal information might not be deleted by Reliht. In order to terminate your Account, and permanently remove your User Content and/or personal information please specifically request such permanent removal within your email when you request a termination. Any User Content that has already been used by Reliht for other purposes prior to your request for permanent removal may continue to be used by Reliht for such other purposes and will not be subject to the permanent removal of the rest of the User’s Account or User Content.
        </li>
      </ol>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        14. ACCOUNT REACTIVATION
      </Typography>
      <ol>
        <li>
          If you have not violated any of the provisions of this Agreement or the Privacy Policy, and provided you have not terminated your Account in accordance with Section 12, your Account may be reactivated by either filling out our <a href="/connect">connect</a> form, or by logging in with your username and password. Reliht assumes no responsibility for any User Account that is no longer available upon such Account reactivation. Reliht may, in its sole discretion, refuse such requests.
        </li>
      </ol>


      <Typography variant="h5" color="primary" className={classes.spacer}>
        15. PROPRIETARY RIGHTS OWNED BY RELIHT
      </Typography>
      <ol>
        <li>
          <u>Proprietary & Confidential.</u> You shall respect our proprietary rights in the Website, App, service content, and software used to provide Reliht services. Proprietary rights include software, patents, trademarks, service marks, copyright, and confidential information or trade secrets.
        </li>
        <li>
          <u>Property of Reliht.</u> All content on the Service, including but not limited to designs, text, graphics, pictures, video, information, software, music, sound and other files, and their selection and arrangement (the "Service Content"), are the proprietary property of Reliht, its Users or its licensors with all rights reserved. No Service Content may be modified, copied, distributed, framed, reproduced, republished, downloaded, displayed, Posted, transmitted or sold in any form or by any means, in whole or in part, without Reliht's express prior written permission.
        </li>
      </ol>


      <Typography variant="h5" color="primary" className={classes.spacer}>
        16. LIMITED LICENSE FOR YOUR USE
      </Typography>

      <ol>
        <li>
          Provided that you are eligible for use of the Service, you are granted a limited, non-exclusive, non-transferable license to access and use the Service and to download or print a copy of any portion of the Service Content solely for your personal, non-commercial use, provided that you keep all copyright or other proprietary notices intact (the "License"). Except for your own User Content, you may not republish Service Content on any Internet, Intranet or Extranet site or incorporate the information in any other database or compilation, and any other use of the Service Content is strictly prohibited.
        </li>
        <li>
          Unless explicitly stated herein, nothing in this Agreement shall be construed as conferring any license to intellectual property rights, whether by implication or otherwise. The License is revocable at any time without notice and with or without cause.
        </li>
      </ol>


      <Typography variant="h5" color="primary" className={classes.spacer}>
        17. TRADEMARKS
      </Typography>
      <br />
      Reliht and other Service graphics, logos, designs, page headers, button icons, scripts and names are copyrighted in the United States and/or other countries by Reliht or its licensors. Reliht's name, trademarks and trade dress may not be used, including as part of trademarks and/or as part of domain names, in connection with any product or service in any manner that is likely to cause confusion and may not be copied, imitated, or used, in whole or in part, without the prior written permission of Reliht.


      <Typography variant="h5" color="primary" className={classes.spacer}>
        18. COPYRIGHT INFRINGEMENT
      </Typography>
      <ol>
        <li>
          <u>Reporting Copyright Violations.</u> If you believe that any material on the Service infringes upon any copyright which you own or control, you may send a written notification of such infringement to our Designated Agent by filling out our <a href="/connect">connect</a> form.
        </li>
        <li>
          <u>Notice Requirements.</u> To meet the notice requirements under the Digital Millennium Copyright Act ("DMCA"), the notification must be a written communication that includes the following:
          <ol type="a">
            <li>
              a physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed;
            </li>
            <li>
              identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single online site are covered by a single notification, a representative list of such works at that site;
            </li>
            <li>
              identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate the material;
            </li>
            <li>
              information reasonably sufficient to permit us to contact the complaining party, such as an address, telephone number and, if available, an email address at which the complaining party may be contacted;
            </li>
            <li>
              a statement that the complaining party has a good-faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent or the law; and
            </li>
            <li>
              a statement that the information in the notification is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.
            </li>
          </ol>
        </li>
        <li>
          <u>Repeat Infringer Policy.</u> In accordance with the DMCA and other applicable law, Reliht has adopted a policy of terminating, in appropriate circumstances and at Reliht's sole discretion, Users accounts who are deemed to be repeat infringers.
        </li>
        <li>
          <u>Termination of Accounts.</u> Reliht may also at its sole discretion limit access to the Service and/or terminate the Accounts of any Users who infringe any intellectual property rights of others, whether or not there is any repeat infringement.
        </li>
      </ol>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        19. COMPLIANCE WITH LAWS
      </Typography>
      <br />
      You represent and warrant that your use of Reliht will comply with all applicable laws and regulations. You're responsible for determining whether our Services are suitable for you to use in light of any regulations such as HIPPA, Data Privacy Laws, or other laws.


      <Typography variant="h5" color="primary" className={classes.spacer}>
        20. DISCLAIMER OF WARRANTIES – NO WARRANTIES ARE GIVEN
      </Typography>
      <br />
      Reliht does not promise that the site or any content, service or feature of the Site will be error-free or uninterrupted, or that any defects will be corrected, or that your use of the site will provide specific results. The site and its content are delivered on an “AS-IS” and “AS-AVAILABLE” basis.
      To the maximum extent permitted by law, we provide the service, materials and information on this WEBSITE, THE APP, AND SERVICES "AS-IS", WITH NO WARRANTIES WHATSOEVER. That means that we don't provide warranties of any kind either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose and statutory warranties.
      YOU UNDERSTAND AND AGREE THAT YOU COPY OR DOWNLOAD OR OTHERWISE OBTAIN MATERIAL, DATA, INFORMATION, PRODUCTS AND SERVICES THROUGH THE USE OF THE SERVICE AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGES TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE COPY OR DOWNLOAD OF SUCH MATERIAL, DATA, INFORMATION, PRODUCTS AND SERVICES.
      Some states or other jurisdictions do not allow the exclusion of implied warranties, so the above exclusions may not apply to you. You may also have other rights that vary from jurisdiction to jurisdiction.


      <Typography variant="h5" color="primary" className={classes.spacer}>
        21. LIMITATION OF LIABILITY
      </Typography>
      <ol>
        <li>
          To the maximum extent permitted by law, YOU ASSUME FULL RESPONSIBILITY FOR ANY LOSS that results from your use of the Reliht website, App and the services, including any copied content or downloads from the website or App. We won't be liable for any indirect, punitive, special or consequential damages under any circumstances, even if they are based on negligence, or when we have been advised of the possibility of those damages.
        </li>
        <li>
          This limitation shall also apply with respect to unauthorized access to or alteration of your transmission or data.
        </li>
        <li>
          This limitation shall apply notwithstanding any failure of essential purpose of any limited remedy and to the fullest extent permitted by law.
        </li>
        <li>
          Without limiting the foregoing, under no circumstances shall Reliht or its licensors be held liable for any delay or failure in performance resulting directly or indirectly from acts of nature, forces, or causes beyond its reasonable control, including, without limitation, Internet failures, computer equipment failures, telecommunication equipment failures, other equipment failures, electrical power failures, strikes, labor disputes, riots, insurrections, civil disturbances, shortages of labor or materials, fires, floods, storms, explosions, acts of God, war, governmental actions, orders of domestic or foreign courts or tribunals, non-performance of third parties, or loss of or fluctuations in heat, light, or air conditioning.
        </li>
      </ol>

      <Typography variant="h5" color="primary" className={classes.spacer}>
        22. INDEMNITY
      </Typography>
      <ol>
        <li>
          You agree to indemnify, defend and hold harmless Reliht and its "Team" (subsidiaries and affiliates, and each of their directors, officers, employees, agents, representatives, contractors, volunteers, licensors and licensees) from any damages, losses, costs and expenses (including attorney fees), incurred in connection with any third party claim or demand arising out of Leader Content, your User Content, your use of the Service, your connection to the Service, your breach of this Agreement or your violation of any law or the rights of such third party.
        </li>
        <li>
          You also agree to indemnify and hold harmless Reliht and Team (as identified in Section 21.1) from any damages, losses, costs and expenses (including attorney fees) that result from third-party claims or actions that you (or someone using your password) did that, if true, would violate this Agreement.
        </li>
        <li>
          Reliht reserves the right, at its own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you hereunder, and you shall cooperate fully as reasonably required by Reliht.
        </li>
      </ol>


      <Typography variant="h5" color="primary" className={classes.spacer}>
        23. GOVERNING LAW – STATE OF MINNESOTA
      </Typography>
      <ol>
        <li>
          Isaiah 601, Inc. is a Minnesota corporation and operates this service from the State of Minnesota, United States of America. This Agreement is entered into in the State of Minnesota, and is governed by the laws and regulations of the State of Minnesota, and where applicable, of the United States of America. Reliht is a Trademark and a registered assumed name of Isaiah 601, Inc.
        </li>
        <li>
          This Agreement and your use of the Service shall be governed and construed in accordance with the laws of the State of Minnesota and the United States of America, therein, excluding the application of any rule or principal of conflict of law that might otherwise refer construction, interpretation, or the resolution of any dispute to the laws of another jurisdiction.
        </li>
        <li>
          Any dispute arising under this Agreement shall be resolved exclusively by the courts located in the State of Minnesota (venue being the Minnesota District Court for the Fourth Judicial District, located in Hennepin County, State of Minnesota), or the Federal District Court for the District of Minnesota. You agree not to bring any legal action against Reliht in any jurisdiction except that stated above, and you agree to and shall submit and consent to such jurisdiction.
        </li>
        <li>
          By using this service and accepting this Agreement, you agree to be subject to the jurisdiction of the courts named above.
        </li>
      </ol>


      <Typography variant="h5" color="primary" className={classes.spacer}>
        24. ENTIRE AGREEMENT; GENERAL PROVISIONS
      </Typography>
      <br />
      This Agreement and the Privacy Policy constitute the entire agreement between the parties with respect to the subject matter hereof and supersedes and replaces all prior or contemporaneous understandings or agreements, written or oral, regarding such subject matter. In the event of any discrepancy between this Agreement and the Privacy Policy, this Agreement shall govern and control. Any waiver of any provision of the Agreement will be effective only if in writing and signed by Reliht. If any provision of this Agreement shall be deemed unlawful, invalid, or unenforceable by a court of law, then the impugned provision shall be deemed severed and shall not affect the validity and enforceability of any remaining provisions. Your use of the Service is not intended and shall not be deemed to create any agency, joint venture or other legal relationship of any kind between you and Reliht other than that of independent contractors.


      <Typography variant="h5" color="primary" className={classes.spacer}>
        25. CHANGES IN TERMS AND CONDITIONS
      </Typography>
      <br />
      We reserve the right to modify the Service from time to time, for any reason, and without notice, including the right to terminate with or without notice, without liability to you, the Account of any other User or any third party.
      <br />
      We reserve the right to modify this Agreement from time to time without notice. Your use of the account will constitute your acceptance of any changes in the terms and conditions of this Agreement. Please review this Agreement from time to time so that you will be apprised of any changes.


      <Typography align="right">
        G105977
      </Typography>


    </Grid>
  );
}
